// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1oW2W","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__Ttmzm"};